import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { init } from '@chamaeleonidae/chmln';

import { ChameleonService } from './chameleon.service';
import { IChameleonConfiguration } from './interfaces';

export function provideChameleon(configuration: IChameleonConfiguration): EnvironmentProviders {
  return makeEnvironmentProviders(
    configuration.enabled
      ? [
          {
            // Lazy: the SDK is loaded on first injection, not at bootstrap.
            provide: ChameleonService,
            useFactory: () => {
              init(configuration.key);
              return new ChameleonService();
            },
          },
        ]
      : [],
  );
}
